<template>
	<VueApexChart
		v-if="chartOptions && hasData"
		ref="chart"
		class="app-chart-range-bar"
		:class="{ 'live': autoUpdate }"
		:style="{ height: chartHeight }"
		:options="chartOptions"
		:series="series"
	/>
	<div v-else class="app-chart-range-bar__empty" :style="{ height: chartHeight }">
		{{ noData }}
	</div>
</template>

<script>
export default {
	props: {
		series: {
			type: Array,
			default: () => []
		},
		height: {
			type: [String, Number],
			default: 350
		},

		title: {
			type: String,
			default: 'Range Bar Chart'
		},

		tooltipTitle: {
			type: String,
			default: 'Value'
		},

		noData: {
			type: String,
			default: 'No Data'
		},

		toolbar: {
			type: Boolean,
			default: true
		},

		autoUpdate: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			chartOptions: null
		}
	},

	computed: {
		hasData () {
			return this.series.some(series => series.data && series.data.length)
		},

		chartHeight () {
			if (typeof this.height === 'number') {
				return `${this.height}px`
			}
			return this.height
		}
	},

	watch: {
		autoUpdate () {
			this.initChart()
		},

		series: {
			handler () {
				this.initChart()
			},
			deep: true
		}
	},

	created () {
		this.initChart()
	},

	methods: {
		initChart () {
			this.chartOptions = {
				chart: {
					type: 'rangeBar',
					zoom: {
						enabled: true
					},
					selection: {
						enabled: true
					},
					toolbar: {
						show: !this.autoUpdate && this.toolbar,
						tools: {
							download: true,
							selection: true,
							zoom: true,
							zoomin: true,
							zoomout: true,
							pan: true,
							reset: true
						}
					}
				},
				plotOptions: {
					bar: {
						horizontal: true,
						barHeight: '80%',
						rangeBarGroupRows: true, // Groups overlapping tasks onto the same row
						borderRadius: 6
					}
				},
				xaxis: {
					type: 'datetime',
					min: this.autoUpdate ? Date.now() - 6 * 60 * 1000 : undefined,
					max: this.autoUpdate ? Date.now() : undefined,
					labels: {
						show: this.hasData,
						datetimeUTC: false,
						datetimeFormatter: {
							hour: 'h TT',
							minute: 'h:mm TT',
							second: 'h:mm:00 TT'
						},
						style: {
							fontSize: '10px'
						}
					}
				},
				yaxis: {
					labels: {
						show: this.hasData,
						style: {
							fontSize: '12px'
						}
					}
				},
				title: {
					text: this.title,
					margin: 10,
					style: {
						color: 'currentColor',
						fontWeight: 'normal',
						fontSize: '12px',
						fontFamily: 'Quicksand, sans-serif'
					}
				},
				tooltip: {
					enabled: true,
					shared: false,
					style: {
						fontSize: '12px'
					},
					x: {
						show: true,
						format: 'MMM dd, yyyy hh:mm TT'
					}
				},
				noData: {
					text: this.noData,
					align: 'center',
					verticalAlign: 'middle',
					style: {
						fontSize: '12px'
					}
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.app-chart-range-bar {
	width: 100%;
	min-height: 0;
	min-width: 0;
	text-transform: capitalize;
	position: relative;

	&.live { pointer-events: none; }

	&__empty {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #aab2bd;
		font-size: 12px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppChartRangeBar.vue